import { Component } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { ButtonMode } from '@fcom/ui-components';

@Component({
  selector: 'fin-special-assistance-wizard',
  templateUrl: './special-assistance-wizard.component.html',
  styleUrls: ['./special-assistance-wizard.component.scss'],
})
export class SpecialAssistanceWizardComponent {
  readonly ButtonMode = ButtonMode;
  readonly SvgLibraryIcon = SvgLibraryIcon;
}
